import React from "react";
import styled from "@emotion/styled";
import logoBlack from "../../../assets/LogoBlack.png";
import logoWhite from "../../../assets/LogoWhite.png";

interface Props {
  menuIsOpen: boolean;
  toggleMenu: () => void;
  currentLanguage: number;
  toggleLanguage: () => void;
  theme: number;
}

const topics = [
  { label: "Home", id: "landing" },
  { label: "Skills", id: "skill" },
  { label: "Experience", id: "experience" },
  { label: "Projects", id: "project" },
  { label: "Education", id: "education" },
  { label: "Contact", id: "contact" },
];

export const Navbar: React.FC<Props> = (props) => {
  const handleScroll = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <NavbarContainer>
      <Left>
        <Logo>
          {props.theme === 1 ? (
            <img src={logoBlack} width={50} height={50} alt="" />
          ) : props.theme === 2 ? (
            <img src={logoBlack} width={50} height={50} alt="" />
          ) : (
            <img src={logoWhite} width={50} height={50} alt="" />
          )}
          {/* <img src={logoBlack} width={50} height={50} alt="" /> */}
        </Logo>
        <Name>
          {props.currentLanguage === 0 ? (
            <div>Watcharapol Treesatthayasakul</div>
          ) : (
            <div>ワットシャらポン トリーサッタヤサクン</div>
          )}
        </Name>
      </Left>
      {/* <Center>

      </Center> */}
      <Right>
        {topics.map((topic, i) => (
          <Topic
            key={topic.id}
            menuIsOpen={props.menuIsOpen}
            index={i}
            onClick={() => handleScroll(topic.id)}
          >
            {topic.label}
          </Topic>
        ))}
        <HamburgerButton
          menuIsOpen={props.menuIsOpen}
          theme={props.theme}
          onClick={() => {
            props.toggleMenu();
            //   props.toggleLanguage();
          }}
        >
          <div></div>
          <div></div>
          <div></div>
        </HamburgerButton>
      </Right>
    </NavbarContainer>
  );
};

const NavbarContainer = styled("nav")({
  // zIndex: "9999",
  height: "60px",
  position: "sticky",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 20px",
  top: 0,
  backdropFilter: "blur(30px)",
  "@media (max-width: 1024px)": {
    justifyContent: "space-between",
  },
  "&::before": {
    content: "''",
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "0%",
    height: "2px",
    animation: "borderAnimation 15s linear infinite",
  },
  "@keyframes borderAnimation": {
    "0%": {
      width: "0%",
    },
    "15%": {
      width: "70%",
    },
    "30%": {
      width: "100%",
    },
    "45%": {
      width: "100%",
    },
    "60%": {
      width: "15%",
    },
    "70%": {
      width: "20%",
    },
    "80%": {
      width: "0%",
    },
  },
});

const Left = styled("div")({
  right: 0,
  display: "flex",
  gap: "20px",
});
const Right = styled("div")({
  right: 0,
  display: "flex",
  gap: "4vw",
  marginRight: "1vw",
  fontSize: "30px",
  alignItems: "center",
  "@media (max-width: 1024px)": {
    gap: "1vw",
  },
  "@media (max-width: 1440px)": {
    gap: "3vw",
    fontSize: "25px",
  },
});
const Logo = styled("div")({
  width: "50px",
  alignContent: "center",
});
const Name = styled("div")({
  alignContent: "center",
  fontSize: "35px",
  fontWeight: "bold",
  // color: "#333",
  "@media (max-width: 1440px)": {
    fontSize: "30px",
  },
});

const topicOffsets = [160, 140, 120, 100, 80, 60]; // ค่าคงที่ของแต่ละตัว

const Topic = styled("li")<{ menuIsOpen: boolean; index: number }>(
  ({ menuIsOpen, index }) => ({
    listStyle: "none",
    textDecoration: "none",
    position: "relative",
    cursor: "pointer",
    transition:
      "color 0.3s ease, text-decoration 0.3s ease, transform 0.5s ease, opacity 0.5s ease",

    transform: menuIsOpen
      ? `translateX(${topicOffsets[index]}px)`
      : "translateX(0px)",
    opacity: menuIsOpen ? 0 : 1,

    "&::after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "0%",
      height: "2px",
      backgroundColor: "#999",
      transition: "width 0.3s ease",
    },

    "&:hover::after": {
      width: "100%",
    },

    "&:hover": {
      color: "#999",
    },
    "@media (max-width: 1024px)": {
      display: "none", // ซ่อน topic เมื่อหน้าจอเล็ก
    },
  })
);

const HamburgerButton = styled("div")<{ menuIsOpen: boolean; theme: number }>(
  {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "30px",
    height: "16px",
    backgroundColor: "transparent",
    border: "none",
    padding: "0",
    cursor: "pointer",
    transition: "transform 0.6s ease-in-out",
    // zIndex: "z-10",
    "@media (max-width: 1024px)": {
      display: "flex",
    },
  },
  ({ menuIsOpen, theme }) => ({
    transform: menuIsOpen ? "rotate(360deg)" : "rotate(0deg)",
    div: {
      height: "2px",
      width: "100%",
      backgroundColor: theme === 1 ? "#000" : theme === 2 ? "#000" : "#fff",
      transition: "transform 0.3s ease, opacity 0.3s ease",
      ":first-of-type": {
        transform: menuIsOpen
          ? "rotate(45deg) translate(5px, 5px)"
          : "rotate(0deg) translate(0, 0)",
      },
      ":nth-of-type(2)": {
        opacity: menuIsOpen ? "0" : "1",
        transition: "transform 0.3s ease, opacity 0.3s ease",
      },
      ":last-of-type": {
        transform: menuIsOpen
          ? "rotate(-45deg) translate(5px, -5px)"
          : "rotate(0deg) translate(0, 0)",
      },
    },
    "&:hover": {
      height: menuIsOpen ? "16px" : "14px",
      paddingTop: "1px",
      paddingBottom: "1px",
      div: {
        ":first-of-type": {
          backgroundColor: "#999",
        },
        ":nth-of-type(2)": {
          width: "100%",
          margin: "auto",
          transition: "transform 0.3s ease, width 0.3s ease",
          backgroundColor: "#999",
        },
        ":last-of-type": {
          backgroundColor: "#999",
        },
      },
    },
  })
);
